import React, { useState } from 'react';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

import './ClientesList.css'; // Import the CSS file

const ClientesList = ({ clientes, onSelectCliente, selectedId, onEdit, onDelete }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  // Get user role from localStorage
  const userRole = localStorage.getItem('userRole') || 'user';
  const userType = localStorage.getItem('userType') || '';
  const isMaster = userType === 'master';
  
  // Ensure clientes is an array before filtering
  const clientesArray = Array.isArray(clientes) ? clientes : [];
  
  const filteredClientes = clientesArray.filter(cliente => 
    cliente?.razaoSocial?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    cliente?.cnpj?.includes(searchTerm) ||
    cliente?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (cliente?.nomeFantasia && cliente.nomeFantasia.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'N/A';
      
      return date.toLocaleDateString('pt-BR');
    } catch (error) {
      return 'N/A';
    }
  };

  return (
    <div className="clientes-list-container">
      <div className="search-container">
        <input
          type="text"
          placeholder="Buscar clientes..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      
      {filteredClientes.length === 0 ? (
        <div className="no-results">
          {searchTerm 
            ? "Nenhum cliente encontrado para esta busca" 
            : "Não há clientes cadastrados"}
        </div>
      ) : (
        <table className="clientes-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>CNPJ</th>
              <th>Data de Cadastro</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredClientes.map((cliente, index) => (
              <tr 
                key={cliente._id || index}
                className={selectedId === cliente._id ? 'selected-row' : ''}
                onClick={() => onSelectCliente(cliente)}
              >
                <td>
                  {cliente.razaoSocial || 'Cliente sem nome'}
                  {cliente.nomeFantasia && (
                    <div className="nome-fantasia">{cliente.nomeFantasia}</div>
                  )}
                </td>
                <td>{cliente.email || 'N/A'}</td>
                <td>
                  <span className="cnpj-text">
                    {cliente.cnpj || 'N/A'}
                  </span>
                </td>
                <td>{formatDate(cliente.createdAt)}</td>
                <td>
                  <div className="action-buttons">
                    {/* Edit button */}
                    <button 
                      className="edit-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        if(typeof onEdit === 'function') {
                          onEdit(cliente);
                        } else {
                          console.error('onEdit is not a function');
                        }
                      }}
                    >
                      <FiEdit />
                    </button>
                    
                    {/* Delete button - only for Master role */}
                    {isMaster && (
                      <button 
                        className="delete-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          if(typeof onDelete === 'function') {
                            onDelete(cliente._id);
                          } else {
                            console.error('onDelete is not a function');
                          }
                        }}
                      >
                        <FiTrash2 />
                        
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ClientesList;